import * as React from "react";
import TextField from "./TextField";
import Label from "./Label";

class Amount extends React.Component<any, any> {

  private handleChange = (val: string) => {
    this.props.onChange({ target: { name: 'amount', value: val.replace('.','') } });
  };

  static format(value: string) {
    let val = Math.max(parseFloat(value.trim().replace('$','')), 0);
    if(isNaN(val) || val == 0) return "";
    return val.toFixed(2);
  }

  public render(){
    const { amount_field, amount_field_value, showErrors, ...other } = this.props;
    if(!amount_field) {
      return <div>
        <Label htmlFor="amount">Amount</Label>
        <span>${amount_field_value}</span>
        <input type="hidden" value={this.props.amount} {...other}/>
      </div>
    }

    return <TextField field="amount"
                      label="Amount"
                      tag="amount_field"
                      showErrors={showErrors}
                      required={true}
                      placeholder="Amount"
                      {...other}
                      defaultValue={amount_field_value}
                      onChange={el => this.handleChange(el.currentTarget.value)}
                      format={Amount.format} />
  }
}

export default Amount;


// WEBPACK FOOTER //
// ./src/checkout/fields/Amount.tsx